"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var d3_selection_1 = require("d3-selection");
var extent_1 = require("ol/extent");
var Point_1 = __importDefault(require("ol/geom/Point"));
var Polygon_1 = __importDefault(require("ol/geom/Polygon"));
var LineString_1 = __importDefault(require("ol/geom/LineString"));
var Immediate_1 = __importDefault(require("ol/render/canvas/Immediate"));
var transform_1 = require("ol/transform");
var geostyler_openlayers_parser_1 = __importDefault(require("geostyler-openlayers-parser"));
var Feature_1 = __importDefault(require("ol/Feature"));
var iconSize = [45, 30];
/**
 * A class that can be used to render svg legends.
 */
var LegendRenderer = /** @class */ (function () {
    /**
     * Constructs a new legend renderer.
     * @param {LegendsConfiguration} config the legend configuration
     */
    function LegendRenderer(config) {
        this.config = null;
        this.config = config;
    }
    /**
     * Constructs a legend configuration from a geostyler style object.
     * @param {Style} style a geostyler style
     */
    LegendRenderer.prototype.extractConfigFromStyle = function (style) {
        var config = {
            items: [],
            title: ''
        };
        if (style.name) {
            config.title = style.name;
        }
        style.rules.forEach(function (rule) {
            config.items.push({
                title: rule.name,
                rule: rule
            });
        });
        return config;
    };
    /**
     * Renders a single legend item.
     * @param {Selection} container the container to append the legend item to
     * @param {LegendItemConfiguration} item configuration of the legend item
     * @param {[number, number]} position the current position
     */
    LegendRenderer.prototype.renderLegendItem = function (container, item, position) {
        var _a = this.config, hideRect = _a.hideRect, maxColumnHeight = _a.maxColumnHeight, maxColumnWidth = _a.maxColumnWidth;
        if (item.rule) {
            container = container.append('g')
                .attr('class', 'legend-item')
                .attr('title', item.title);
            return this.getRuleIcon(item.rule)
                .then(function (uri) {
                if (!hideRect) {
                    container.append('rect')
                        .attr('x', position[0] + 1)
                        .attr('y', position[1])
                        .attr('width', iconSize[0])
                        .attr('height', iconSize[1])
                        .style('fill-opacity', 0)
                        .style('stroke', 'black');
                }
                container.append('image')
                    .attr('x', position[0] + 1)
                    .attr('y', position[1])
                    .attr('width', iconSize[0])
                    .attr('height', iconSize[1])
                    .attr('href', uri);
                container.append('text')
                    .text(item.title)
                    .attr('x', position[0] + iconSize[0] + 5)
                    .attr('y', position[1] + 20);
                position[1] += iconSize[1] + 5;
                if (maxColumnHeight && position[1] + iconSize[1] + 5 >= maxColumnHeight) {
                    position[1] = 5;
                    position[0] += maxColumnWidth;
                }
            })
                .catch(function () {
                return undefined;
            });
        }
        return undefined;
    };
    /**
     * Shortens the labels if they overflow.
     * @param {Selection} nodes the legend item group nodes
     * @param {number} maxWidth the maximum column width
     */
    LegendRenderer.prototype.shortenLabels = function (nodes, maxWidth) {
        nodes.each(function () {
            var node = (0, d3_selection_1.select)(this);
            var text = node.select('text');
            if (!(node.node() instanceof SVGElement)) {
                return;
            }
            var elem = (node.node());
            var width = elem.getBoundingClientRect().width;
            var adapted = false;
            while (width > maxWidth) {
                var str = text.text();
                str = str.substring(0, str.length - 1);
                text.text(str);
                width = elem.getBoundingClientRect().width;
                adapted = true;
            }
            if (adapted) {
                var str = text.text();
                str = str.substring(0, str.length - 3);
                text.text(str + '...');
            }
        });
    };
    /**
     * Constructs a geometry for rendering a specific symbolizer.
     * @param {Symbolizer} symbolizer the symbolizer object
     */
    LegendRenderer.prototype.getGeometryForSymbolizer = function (symbolizer) {
        var kind = symbolizer.kind;
        switch (kind) {
            case 'Mark':
            case 'Icon':
            case 'Text':
                return new Point_1.default([iconSize[0] / 2, iconSize[1] / 2]);
            case 'Fill':
                return new Polygon_1.default([[
                        [3, 3], [iconSize[0] - 3, 3], [iconSize[0] - 3, iconSize[1] - 3],
                        [3, iconSize[1] - 3], [3, 3]
                    ]]);
            case 'Line':
                return new LineString_1.default([
                    [iconSize[0] / 6, iconSize[1] / 6],
                    [iconSize[0] / 3, iconSize[1] / 3 * 2],
                    [iconSize[0] / 2, iconSize[1] / 3],
                    [iconSize[0] / 6 * 5, iconSize[1] / 6 * 5]
                ]);
            default:
                return new Point_1.default([iconSize[0] / 2, iconSize[1] / 2]);
        }
    };
    /**
     * Returns a promise resolving to a data uri with the appropriate rule icon.
     * @param {Object} rule the geostyler rule
     */
    LegendRenderer.prototype.getRuleIcon = function (rule) {
        var _this = this;
        var canvas = document.createElement('canvas');
        canvas.setAttribute('width', "" + iconSize[0]);
        canvas.setAttribute('height', "" + iconSize[1]);
        var extent = (0, extent_1.boundingExtent)([[0, 0], [iconSize[0], iconSize[1]]]);
        var pixelRatio = 1;
        var context = canvas.getContext('2d');
        var transform = (0, transform_1.create)();
        var renderer = new Immediate_1.default(context, pixelRatio, extent, transform, 0);
        var geoms = [];
        rule.symbolizers.forEach(function (symbolizer) { return geoms.push(_this.getGeometryForSymbolizer(symbolizer)); });
        var styleParser = new geostyler_openlayers_parser_1.default();
        var style = {
            name: '',
            rules: [{
                    name: '',
                    symbolizers: rule.symbolizers
                }]
        };
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            function drawGeoms() {
                geoms.forEach(function (geom) { return renderer.drawGeometry(geom); });
            }
            var _a, olStyle, _b, errors, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, styleParser.writeStyle(style)];
                    case 1:
                        _a = _c.sent(), olStyle = _a.output, _b = _a.errors, errors = _b === void 0 ? [] : _b;
                        if (errors.length > 0) {
                            reject(errors[0]);
                        }
                        if (typeof olStyle == 'function') {
                            olStyle = olStyle(new Feature_1.default(geoms[0]), 1);
                        }
                        if (Array.isArray(olStyle)) {
                            olStyle.forEach(function (styleItem) {
                                renderer.setStyle(styleItem);
                                drawGeoms();
                            });
                        }
                        else {
                            renderer.setStyle(olStyle);
                            drawGeoms();
                        }
                        resolve(canvas.toDataURL('image/png'));
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _c.sent();
                        reject();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    };
    ;
    /**
     * Render a single legend.
     * @param {LegendConfiguration} config the legend config
     * @param {Selection} svg the root node
     * @param {[number, number]} position the current position
     */
    LegendRenderer.prototype.renderLegend = function (config, svg, position) {
        var _this = this;
        var container = svg.append('g');
        if (this.config.overflow !== 'auto' && position[0] !== 0) {
            var legendHeight = config.items.length * (iconSize[1] + 5) + 20;
            if (legendHeight + position[1] > this.config.maxColumnHeight) {
                position[0] += this.config.maxColumnWidth;
                position[1] = 0;
            }
        }
        if (config.title) {
            container.append('text')
                .text(config.title)
                .attr('class', 'legend-title')
                .attr('text-anchor', 'start')
                .attr('dy', '1em')
                .attr('dx', position[0]);
            position[1] += 20;
        }
        return config.items.reduce(function (cur, item) {
            return cur.then(function () { return _this.renderLegendItem(svg, item, position); });
        }, Promise.resolve());
    };
    /**
     * Renders the configured legend.
     * @param {HTMLElement} target a node to append the svg to
     * @return {Promise<void>} a promise resolving once the legend has finished rendering
     */
    LegendRenderer.prototype.render = function (target) {
        var _this = this;
        var _a = this.config, styles = _a.styles, configs = _a.configs, _b = _a.size, width = _b[0], height = _b[1];
        var legends = [];
        if (styles) {
            styles.forEach(function (style) { return legends.push(_this.extractConfigFromStyle(style)); });
        }
        if (configs) {
            legends.unshift.apply(legends, configs);
        }
        var svgClass = 'geostyler-legend-renderer';
        var parent = (0, d3_selection_1.select)(target);
        parent.select("." + svgClass).remove();
        var svg = parent
            .append('svg')
            .attr('class', svgClass)
            .attr('viewBox', "0 0 " + width + " " + height)
            .attr('top', 0)
            .attr('left', 0)
            .attr('width', width)
            .attr('height', height);
        var position = [0, 0];
        var promise = legends.reduce(function (cur, legend) {
            return cur.then(function () { return _this.renderLegend(legend, svg, position); });
        }, Promise.resolve());
        return promise.then(function () {
            var nodes = svg.selectAll('g.legend-item');
            _this.shortenLabels(nodes, _this.config.maxColumnWidth);
            if (!_this.config.maxColumnHeight) {
                svg
                    .attr('viewBox', "0 0 " + width + " " + position[1])
                    .attr('height', position[1]);
            }
        });
    };
    return LegendRenderer;
}());
exports.default = LegendRenderer;
